import { ButtonPrimary } from '@spotify-internal/encore-web';
import { HeroBanner } from '@spotify-internal/encore-web/content-platform/components/HeroBanner';
import { ContainerDarkTheme } from '@components/shared/styles';
import { login } from '@lib/auth';

export const Landing = () => {
  return (
    <ContainerDarkTheme>
      {/* @ts-ignore */}
      <HeroBanner
        superheading="Welcome!"
        // heading={
        //   <>
        //     <Type as="h1" variant="display2" semanticColor="textBase">
        // //      TODO: Update copy before launch
        //     </Type>
        //   </>
        // }
        // // details={
        // //   <>
        // //     <Type as="p" variant="body1" semanticColor="textBase">
        // //      TODO: Update copy before launch
        // //     </Type>
        // //   </>
        // // }
      >
        <ButtonPrimary onClick={() => login()}>Log in</ButtonPrimary>
      </HeroBanner>
    </ContainerDarkTheme>
  );
};
